import _slicedToArray from "/home/runner/work/jfssvex.github.io/jfssvex.github.io/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/home/runner/work/jfssvex.github.io/jfssvex.github.io/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import { useCallback, useMemo, useState } from "react";
import { useSafeLayoutEffect, useForceUpdate } from "@chakra-ui/hooks";
export function useDescendant(props) {
  var context = props.context,
      element = props.element,
      indexProp = props.index,
      disabled = props.disabled,
      focusable = props.focusable,
      rest = _objectWithoutPropertiesLoose(props, ["context", "element", "index", "disabled", "focusable"]);

  var forceUpdate = useForceUpdate();
  var register = context.register,
      unregister = context.unregister,
      descendants = context.descendants;
  useSafeLayoutEffect(function () {
    if (!element) {
      forceUpdate();
    }
    /**
     * Don't register this descendant if it's disabled and not focusable
     */


    if (disabled && !focusable) return;
    /**
     * else, register the descendant
     */

    register(_extends({
      element: element,
      disabled: disabled,
      focusable: focusable
    }, rest));
    /**
     * when it unmounts, unregister the descendant
     */

    return function () {
      if (element) {
        unregister(element);
      }
    }; //eslint-disable-next-line
  }, [element, disabled, focusable].concat(_toConsumableArray(Object.values(rest))));
  var index = indexProp != null ? indexProp : descendants.findIndex(function (descendant) {
    return descendant.element === element;
  });
  return index;
}
export function useDescendants() {
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      descendants = _useState2[0],
      setDescendants = _useState2[1];

  var register = useCallback(function (_ref) {
    var element = _ref.element,
        rest = _objectWithoutPropertiesLoose(_ref, ["element"]);

    if (!element) return; //@ts-ignore

    setDescendants(function (prevDescendants) {
      if (prevDescendants.find(function (item) {
        return item.element === element;
      }) == null) {
        var index = prevDescendants.findIndex(function (item) {
          if (!item.element || !element) return false;
          return Boolean(item.element.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_PRECEDING);
        });

        var newItem = _extends({
          element: element
        }, rest);

        if (index === -1) {
          return [].concat(_toConsumableArray(prevDescendants), [newItem]);
        }

        return [].concat(_toConsumableArray(prevDescendants.slice(0, index)), [newItem], _toConsumableArray(prevDescendants.slice(index)));
      }

      return prevDescendants;
    });
  }, []);
  var unregister = useCallback(function (element) {
    if (!element) return;
    setDescendants(function (descendants) {
      return descendants.filter(function (descendant) {
        return element !== descendant.element;
      });
    });
  }, []);
  var context = useMemo(function () {
    return {
      descendants: descendants,
      register: register,
      unregister: unregister
    };
  }, [descendants, register, unregister]);
  return context;
}